import React, { useEffect, useState } from "react";
import axiosInstance from "../../Api/axios.instance";
// For admin cards, the file name is ClusterMetabase 
// For Cluster cards, the file name is AdminMetabase 
const drilldownclusterMap = {
  //1: 47, // Schools
  1: 373, // Schools
  2: 374, // Students
  3: 375, // Parents
  4: 376, // Orphans
  5: 377, // Zakat Deserving
  6: 378, // Missing CNIC
  7: 379, // Principals
  8: 380, // Teachers
  9: 381, // Non-Teaching
 10: 382, // Teacher Observation
 11: 383, // Admissions
 12: 384, // Dropouts
 13: 385, // Monthly Fees Collection Details
 14: 386, // All Fee Heads Collection Details
 15: 387, // Underprivileged Students
 16: 388, // Student Age Below Four
 17: 389, // PTM
 18: 390, // Tasks
 19: 391,  // Student by Gender
 20: 392,  // Students by Class
};

const cardPositions = {
  1: { top: "2.8%", left: "1.5%", width: "24%", height: "10%" },   // Students Previous Schools
  2: { top: "2.8%", left: "26%", width: "24%", height: "10%" },    // Parents
  3: { top: "2.8%", left: "50.5%", width: "24%", height: "10%" },  // Orphans
  4: { top: "2.8%", left: "75%", width: "24%", height: "10%" },    // Zakat Deserving

  5: { top: "13%", left: "1.5%", width: "24%", height: "10%" },  // Missing CNIC
  6: { top: "13%", left: "26%", width: "24%", height: "10%" },   // Principal
  7: { top: "13%", left: "50.5%", width: "24%", height: "10%" }, // Teachers
  8: { top: "13%", left: "75%", width: "24%", height: "10%" },   // Non-Teaching

  9: { top: "23.3%", left: "1.5%", width: "24%", height: "9.8%" },  // Teacher Observation
 10: { top: "23.3%", left: "26%", width: "24%", height: "9.8%" },   // Admission From July
 11: { top: "23.3%", left: "50.5%", width: "24%", height: "9.8%" }, // Dropout From July
 12: { top: "23.3%", left: "75%", width: "24%", height: "9.8%" },   // Non-Teaching

 13: { top: "33.5%", left: "1.5%", width: "24%", height: "9.8%" }, // Monthly Fees Collection Details
 14: { top: "33.5%", left: "26%", width: "24%", height: "9.8%" }, // All Fee Heads Collection Details
 15: { top: "33.5%", left: "50.5%", width: "24%", height: "9.8%" }, // Underprivileged Students
 16: { top: "33.5%", left: "75%", width: "24%", height: "9.8%" }, // Student Age Below Four

 17: { top: "43.55%", left: "38%", width: "24%", height: "9.8%" }, // PTM
//  18: { top: "43.55%", left: "26%", width: "24%", height: "9.8%" }, // Tasks

 19: { top: "53.75%", left: "1.5%", width: "44%", height: "20%" }, // Students By Gender 
 20: { top: "53.75%", left: "47%", width: "50%", height: "20%" } // Students By Class

};

const ClusterMetabase = () => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [mode, setMode] = useState("clusterdashboard"); // 'dashboard' or 'question'

  useEffect(() => {
    loadclusterDashboard();
  },[]);

  const loadclusterDashboard = () => {
    axiosInstance
      .get("/metabase/clusterdashboard")
      .then((res) => {
        setIframeUrl(res.data.url);
        setMode("clusterdashboard");
      });
  };

  const loadclusterDrilldown = (cardId) => {
    const questionId = drilldownclusterMap[cardId];
    if (!questionId) return;

    axiosInstance.get(`/metabase/clusterquestion/${questionId}`)
    .then((res) => {
        setIframeUrl(res.data.url);
        setMode("clusterquestion");
      });
  };
  
  return (
    <div style={{ position: "relative" }}>
      {iframeUrl ? (
        <>
          <iframe
            src={iframeUrl}
            frameBorder="0"
            width="100%"
            height={1350}
            allowTransparency
            title="Metabase"
          />
          {mode === "clusterdashboard" &&
            Object.entries(cardPositions).map(([cardId, pos]) => (
              <div
                key={cardId}
                onClick={() => loadclusterDrilldown(cardId)}
                style={{
                  position: "absolute",
                  ...pos,
                  zIndex: 10,
                  cursor: "pointer",
                }}
              />
            ))}
          {mode === "clusterquestion" && (
            <button
              onClick={loadclusterDashboard}
              style={{
                position: "absolute",
                top: 8,
                right: 16,
                zIndex: 20,
                backgroundColor: "#0072BB", 
                color: "white",
                padding: "8px 16px",
                fontSize: "10px",
                fontWeight: "500",
                border: "none",
                borderRadius: "6px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                cursor: "pointer",
              }}
            >
              ← Back to Admin Dashboard
            </button>
          )}
        </>
      ) : (
        <p>Loading Admin Dashboard...</p>
      )}
    </div>
  );
};

export default ClusterMetabase;
